
require.register("heap/index.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "heap");
  (function() {
    module.exports = require('./lib/heap');
  })();
});